export const Loader = () => {
  return (
    <div className="d-flex justify-content-center align-item-center h-100">
      <span className="spinner-grow" role="status"></span>
    </div>
  );
};
